export default {
    menu: "Menu",
    close_menu: "Fechar Menu",
    viewing_as: "Visualizando como:",

    // Menu items
    pdv: "PDV",
    tasks: "Tarefas",
    tasks_list: "Lista",
    tasks_boards: "Quadros",

    metrics: "Métricas",
    rfm_analysis: "Análise RFM",
    sales: "Vendas",
    retention_cohort: "Retenção e Cohorte",
    clients: "Clientes",
    messages: "Mensagens",
    quotations: "Orçamentos",

    forms: "Formulários",
    forms_manage: "Gerenciar Formulários",
    forms_answers: "Respostas",

    contacts: "Contatos",
    contact_base: "Base de Contatos",
    coupons_list: "Lista de Cupons",
    segments: "Segmentos",
    inbox: "Respostas",

    marketing_actions: "Ações de Marketing",

    benefits_center: "Central de Benefícios",
    settings: "Configurações",
    users: "Usuários",
    data_sets: "Conjunto de Dados",
    connections: "Conexões",
    whatsapp_connections: "Conexões de WhatsApp",
    credits: "Créditos",
    custom_events: "Eventos Personalizados",
    client_fields: "Campos do cliente",
    order_fields: "Campos do pedido",
    quotation_fields: "Campos do orçamento",
    order_status: "Status de pedido",
    quotation_status: "Status de orçamento",
    notification_schedule: "Horários de Envio de Notificações",
    utm_auto: "UTM Automático",
    agent_authorizations: "Autorizações do agente",
    products: "Produtos",
    files_gallery: "Galeria de Arquivos",
    client_base_management: "Gestão da base de clientes",
    import_history: "Importar dados",

    establishments: "Estabelecimentos",
    list: "Lista",
    plans: "Planos",
    adoption_report: "Relatório de Adesão",
    translations: "Traduções",
    email: "Email",
    email_generator: "Gerador de E-mail",

    my_account: "Minha Conta",
    hello: "Olá, {0}!",
    reset_password: "Redefinir Senha",
    my_profile: "Meu perfil",
    two_factor_auth: "Autenticação 2FA",
    logout: "Sair",

    support: "Suporte",
    navigate: "Navegar",
    close: "Fechar",
    logo_alt: "Logo da Kevi",

    // Logout confirmation
    logout_title: "Sair",
    logout_message: "Deseja continuar a ação e sair do sistema?",
    no: "Não",
    yes: "Sim",
};
